import { resolveTextDirection } from '@/utils/helpers/language.helper';
import { Tooltip, TooltipProps } from 'primereact/tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledIcon = styled.i`
  display: inline-flex;
  vertical-align: middle;
  font-size: var(--xsmall-font-size);
  color: var(--gray-darker);
  cursor: pointer;
`;

type AppIconTooltipPropsType = {
  target: string;
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  dir?: 'rtl' | 'ltr';
} & TooltipProps;

export const AppIconTooltip: React.FC<AppIconTooltipPropsType> = ({
  target,
  content,
  position = 'top',
  dir,
  ...rest
}) => {
  const { i18n } = useTranslation();
  const resolvedDir = dir ?? resolveTextDirection(i18n.language);
  return (
    <>
      <Tooltip
        target={`#${target}`}
        content={content}
        position={position}
        my={position === 'top' ? 'center bottom-10' : undefined}
        pt={{ root: { dir: resolvedDir } }}
        {...rest}
      />
      <StyledIcon className="pi pi-info-circle ml-1" id={target} />
    </>
  );
};
